import React from 'react';

const aboutUsLinks = [
  {
    text: 'About PetSafe',
    href: 'https://www.petsafe.com/about-us/',
  },
  {
    text: 'Press Releases',
    href: 'https://www.petsafe.com/press/',
  },
  {
    text: 'Careers',
    href: 'https://www.petsafe.com/about-us/working-at-petsafe/',
  },
  {
    text: 'Bark for Your Park',
    href: 'https://www.petsafe.com/unleashed/',
  },
  {
    text: 'Community Outreach',
    href: 'https://www.petsafe.com/about-us/community-outreach/',
  },
  {
    text: 'Join Our Testing Panel',
    href: 'https://www.petsafe.com/about-us/joinpanel/',
  },
  {
    text: 'Affiliate Program',
    href: 'https://www.petsafe.com/about-us/petsafe-affiliate-program/',
  },
];

const AboutUsList = () => (
  <ul className="m-0 p-0 list-none">
    {aboutUsLinks.map(link => (
      <li key={link.text}>
        <a
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center text-white leading-8 no-underline hover:underline"
        >
          {link.text}
        </a>
      </li>
    ))}
  </ul>
);

export default AboutUsList;
